let operation = [
  {
    path: '/operation_order_detail',
    name: '预约详情',
    component: () => import('@/pages/operation/operation_order_detail')
  },
  {
    path: '/operation_ask_fw',
    name: '提交资料',
    component: () => import('@/pages/operation/operation_ask_fw')
  }
]

export default operation
